// extracted by mini-css-extract-plugin
export default {"page":"pX-z","cartModal":"qX-z","checkout":"rX-z","placeholder":"sX-z","account":"tX-z"};